import { Destination } from '@types'

export const mapDestinationsToCombo = (destinations?: Destination[]) =>
  destinations
    ? destinations.map(({ tag: label, id: value }) => ({
        label,
        value,
      }))
    : undefined
